import { getMemberTransactions, loadNextMemberTransactions, logger } from '@vista/omnichannel-components-domain';
import { MemberTransactionListMessageType } from '../subcomponents/message';
import { MemberTransactionListActionType as ActionType } from './action-type';
export const loadNextTransactions = async (dispatch, numberOfTransactionsToLoad) => {
    dispatch({ type: ActionType.SetIsLoading, isLoading: true });
    try {
        await loadNextMemberTransactions(numberOfTransactionsToLoad);
        const transactions = getMemberTransactions();
        if (!transactions) {
            dispatch({ type: ActionType.SetIsLoading, isLoading: false });
            return;
        }
        if (transactions.length === 0) {
            updateMemberTransactionListErrorMessageType(dispatch, MemberTransactionListMessageType.NoMemberTransactionData);
        }
        dispatch({ type: ActionType.SetIsLoading, isLoading: false });
    }
    catch (error) {
        handleApiError(`Failed to fetch transaction list. ${error}`, dispatch);
        updateMemberTransactionListErrorMessageType(dispatch, MemberTransactionListMessageType.FailedToLoadData);
        dispatch({ type: ActionType.SetIsLoading, isLoading: false });
    }
};
const handleApiError = (logMessage, dispatch) => {
    dispatch({ type: ActionType.SetFailedToLoadTransactions, failedToLoadTransactions: true });
    updateMemberTransactionListErrorMessageType(dispatch, MemberTransactionListMessageType.FailedToLoadData);
    logger.error(logMessage);
};
const updateMemberTransactionListErrorMessageType = (dispatch, newErrorMessage) => {
    dispatch({ type: ActionType.SetErrorMessageType, errorMessageType: newErrorMessage });
};
